<template>
<div id="in_az_app">
    <div class="header">
        <div>
            <span class="button-block">
            <router-link :to="{ name: 'groups-list'}" data-toggle="tooltip" title="Группы">
                <div class="icon list-icon"></div>
            </router-link>
            <router-link :to="{ name: 'user-cabinet'}" data-toggle="tooltip" title="Настройки пользователя">
                <div class="icon user-icon"></div>
            </router-link>
            <a class="logout" @click="logout" data-toggle="tooltip" title="Выход">
            <div></div>
            </a>
        </span>
        </div>
    </div>
    <div class="content-block">
        <router-view></router-view>
    </div>
    <div class="footer">
        <div>
            <span>© AquaZor, 2019</span>
        </div>
        <div>
            <span style="right: 0">Техподдержка:
                <a href="mailto:support@aquazor.ru">support@aquazor.ru</a>
                <a href="tel:+74951202269">+7(495) 120-22-69</a>
            </span>
        </div>
    </div>
</div>
</template>

<script>
import '@/assets/css/main.css'
import '@/assets/css/inmain.css'
import '@/assets/css/icons.css'
import auth from '@/auth.js'
import {
    store
} from '@/store'

export default {
    created() {
        var html_elements = document.getElementsByTagName('html');
        for (var i = 0; i < html_elements.length; i++) {
            html_elements[i].className = "in_main";
        }
    },
    data() {
        return {
            to_groups_list: true
        }
    },
    methods: {
        logout() {
            auth.logout((result) => {
                if (result) {
                    this.$router.replace('/')
                }
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/layouts/AppLayout.vue